"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = __importDefault(require("../../../index"));
var Button_1 = __importDefault(require("../../../Elements/Button"));
var Formik_1 = __importDefault(require("../../../Elements/Checkbox/Single/Formik"));
var DashboardFilterForm = function (_a) {
    var mutation = _a.mutation, sensorSelect = _a.sensorSelect, containerTypeSelect = _a.containerTypeSelect, wasteFractionSelect = _a.wasteFractionSelect, pickupSettingsSelect = _a.pickupSettingsSelect, onSuccess = _a.onSuccess;
    return (react_1.default.createElement(index_1.default, { skipMutation: true, onSuccess: onSuccess, formikProps: {
            initialValues: {
                showDepots: true,
                showContainers: true,
            },
            onSubmit: function () { return console.log("not-used"); },
        }, mutation: mutation, mutationVariablesFormatter: function (v) { return v; } }, function (_a) {
        var isSubmitting = _a.isSubmitting, submitForm = _a.submitForm;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            sensorSelect,
            containerTypeSelect,
            wasteFractionSelect,
            pickupSettingsSelect,
            react_1.default.createElement(Formik_1.default, { antd: {
                    label: "",
                    labelCol: { span: 24, offset: 0 },
                }, name: "showContainers", description: "Show containers" }),
            react_1.default.createElement(Formik_1.default, { antd: {
                    label: "",
                    labelCol: { span: 24, offset: 0 },
                }, name: "showDepots", description: "Show depots" }),
            react_1.default.createElement(Button_1.default, { type: "primary", disabled: isSubmitting, title: "Filter", onClick: submitForm })));
    }));
};
exports.default = DashboardFilterForm;
